export default "/_next/static/images/2023-3x-d9bd775449078455785415703bcf0a4a.png";